var m = require('mithril');
var prop = require("mithril/stream");
var moment = require('moment-timezone');
var modal = require('../../layout/components/modal');
var key = require('../../libs/keybindings');
var Model = require('../../libs/Model');
var choices = require('../../libs/choices');

var filterGroupsModal = Object.create(Model);


modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});


filterGroupsModal.editDialogue = function (groups, groupsSelected, callbackFunction) {
  filterGroupsModal.groups = groups;
  filterGroupsModal.groupsSelected = groupsSelected;
  filterGroupsModal.callbackFunction = callbackFunction
  key.setScope('modal');
  modal.vm.title('Select groups: ');
  modal.vm.body = filterGroupsModal.view, 
  modal.vm.open({
    extrawidth: true
  });
}

filterGroupsModal.view = function () {
  return m('div.mb2',[
    m('div.mr2', 'Groups'),
    m('div', [
      m(choices, { 
        data: filterGroupsModal.groups, 
        value: filterGroupsModal.groupsSelected,
        onchange: () => {
          filterGroupsModal.callbackFunction();
        }
      })
    ])
  ])
}
module.exports = filterGroupsModal;